
const doctors = 'Faculty'
const comment = 'Comment'
module.exports = {
    session_item: {
        time: 'time',
        topics: 'Topic',
        doctors
    },
    meeting_tab: {
        schedule: 'Schedule',
        comment,
        doctors
    },
    meeting: {
        live_end: 'Live is over.-Please click for a playback.',
        live_edited: 'The playback video is being edited. Coming soon.',
        count_down: 'Count down',
        reserved: 'Reserved',
        appointment: 'Appointment',
        pv_total: 'PV Statistics',
        pv_doctor: 'PV of doctor',
        pv_hospital: 'PV of hospital',
        other_session: 'Other Session',
        play_fail: 'Loading failed，retry'
    },
    comment: {
        comment,
        comment_placehold: 'write a comment',
        comment_dialog_placehold: 'recommend to input (10 characters or more) comments.',
        cancel: 'Cancel',
        send: 'Send',
        sending: 'Sending',
        reply: 'Reply',
        copy: 'Copy',
        delete: 'Delete',
        delete_confirm: 'Confirm deletion',
        delete_tips: 'Do you want to delate this comment？',
        delete_success: 'Deletion succeeded',
        delete_fail: 'Deletion failed',
        no_comment: 'No comment',
        comment_list: 'Comment list',
        no_more: 'No more'
    },
    appointment_dialog: {
        success: 'Congratulations-The appointment is successful-There will be SMS reminder before the meeting.',
        confirm: 'Confirm',
    }
}